import { resizeStatusCounts } from './ResizeStatusCounts';
import { addGray } from './ApplyStatusFilter';

const getColorTrend = (data, color) => {
    return data
        .map((item) => addGray(item))
        .map((origItem) => {
            const resizedItem = resizeStatusCounts(origItem);
            const value = resizedItem.value ? resizedItem.value[color] : undefined;
            const orig = origItem.value ? origItem.value[color] : undefined;
            return {
                date: origItem.date,
                value,
                orig,
            };
        });
};

export const statusCountsToMetrics = (data, times) => {
    const granularity = times?.granularity;
    return {
        trends: {
            gray: {
                data: getColorTrend(data, 'gray'),
                granularity,
            },
            green: {
                data: getColorTrend(data, 'green'),
                granularity,
            },
            yellow: {
                data: getColorTrend(data, 'yellow'),
                granularity,
            },
            orange: {
                data: getColorTrend(data, 'orange'),
                granularity,
            },
            red: {
                data: getColorTrend(data, 'red'),
                granularity,
            },
            blank: {
                data: getColorTrend(data, 'blank'),
                granularity,
            },
        },
    };
};
